/*
 * @Author: Mr.mjc
 * @Date: 2022-06-28 10:56:19
 * @LastEditors: yxr
 * @LastEditTime: 2025-11-20 15:29:49
 * @Description:
 * @FilePath: \next-ui\packages\wui-table\src\lib\filterColumn.tsx
 */
// import PropTypes from "prop-types";
import React, {Component, ReactNode} from "react";
// import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import Draggable from 'react-draggable'
import {ConfigContext} from '../../../wui-provider/src/context';
import Button from "../../../wui-button/src";
import Checkbox from "../../../wui-checkbox/src";
import {prefix} from "../../../wui-core/src/index"
import Icon from "../../../wui-icon/src";
import Input from "../../../wui-input/src";
import Message from "../../../wui-message/src";
import i18n from "./i18n";
import {ObjectAssign} from "./util";
import {getLangInfo} from "../../../wui-locale/src/tool";
import {WithConfigConsumer} from "../../../wui-provider/src/context";
import { TableProps, IFilterColumnState, ColumnType, FixedType } from '../iTable';
import { TableInterface } from "../index";
import { ConfigConsumerProps } from "../../../wui-provider/src/iProvider";
import cacheTarget from './cache';
import { normalize } from '../lib/utils';
import { innerColumnKeys } from '../constant'

/**
 * 参数: 过滤表头
 * @param {*} Table
 * @param {*} Popover
 * @param {*} Icon
 */

// 定义拖拽相关状态借口
interface ExtendedFilterColumnState extends IFilterColumnState {
    draggingIndex: number | null;
    draggedItem: ColumnType | null;
    originalPosition: { x: number, y: number } | null; // 记录拖拽item原始位置
    originalMovePosition: { x: number, y: number } | null; // 记录移动item原始位置
    startClient: { x: number, y: number } | null; // 记录开始鼠标位置
    diffClient: { x: number, y: number } | null; // 记录偏移量
    isDraggingOutside: boolean; // 是否拖拽到外部
    placeholderIndex: number | null; // 占位符位置
    draggedElementRect: DOMRect | null; // 记录拖拽元素的原始位置信息
    // isReturning: boolean; // 是否正在从容器外归位
}
export default function filterColumn(Table: React.ComponentClass<Partial<TableProps>> | TableInterface) {
    class FilterColumn extends Component<TableProps, ExtendedFilterColumnState> {
		static contextType = ConfigContext;
		static defaultProps = {
		    prefixCls: `${prefix}-table`,
		    afterFilter: () => {},
		    columnFilterAble: true,
		    scroll: {},
		    // locale: 'zh-cn',
		    lockable: 'enable', // 是否开启锁定列功能
		    filterCheckboxProps: (_column?: ColumnType) => {}
		};

		dragArr: ColumnType[] = [];
		unDragArrLeft: ColumnType[] = [];
		unDragArrRight: ColumnType[] = [];
		context!: ConfigConsumerProps;
		showColumnsKeys: any[];
        dragContainerRef: React.RefObject<HTMLDivElement> = React.createRef();
        itemRefs: Map<string, HTMLDivElement> = new Map();
        returnTimer: any = null;
        scrollTimer: any = null;
        scrollContainerRef: React.RefObject<HTMLDivElement> = React.createRef();

        constructor(props: TableProps) {
		    super(props);
		    let {columns, cacheId, children} = props;
		    if (columns === undefined && children && Array.isArray(children) && children.length > 0) {
		        columns = normalize(children)
		    }
		    if (cacheId && typeof cacheId === 'string') {
		        columns = cacheTarget.get(cacheId, columns)
		    }
		    this.showColumnsKeys = [];
		    this.state = {
		        columns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[]),
		        tempColumns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[]), // 修改，未确定之前，临时的变量,popover展示的数据源
		        srcColumns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[]), // 最原始的数据源
		        showModal: props.columnSetPopover || false,
		        searchStr: '',
		        adaptiveHeight: 0,
                draggingIndex: null,
		        draggedItem: null,
                originalPosition: null,
                originalMovePosition: null,
                startClient: null,
                diffClient: {x: 0, y: 0},
                isDraggingOutside: false,
                placeholderIndex: null,
                draggedElementRect: null,
                // isReturning: false,
		    };
        }

		setColumOrderByIndex = (_column: ColumnType[]) => {
		    _column.forEach((da: ColumnType) => {
		        // 默认所有的列都显示，如果传递ifshow属性，根据ifshow属性值来判断是否显示某列
		        if (da.hasOwnProperty("ifshow")) {
		            da.checked = !!da.ifshow;
		            da.ifshow = da.checked;
		            da.isShow = da.checked;
		            if (da.ifshow) {
		                this.showColumnsKeys.push(da.dataIndex)
		            }
		        } else if (da.hasOwnProperty("isShow")) {
		            da.checked = !!da.isShow;
		            da.ifshow = da.checked;
		            da.isShow = da.checked;
		            if (da.isShow) {
		                this.showColumnsKeys.push(da.dataIndex)
		            }
		        } else {
		            da.checked = true;
		            da.ifshow = true;
		            da.isShow = true;
		            this.showColumnsKeys.push(da.dataIndex)
		        }
		    });
		    return _column;
		};

		UNSAFE_componentWillReceiveProps(nextProps: TableProps) {
		    if (nextProps.columns != this.props.columns || nextProps.children !== this.props.children) {
		        let {columns, cacheId, children} = nextProps;
		        if (columns === undefined && children && Array.isArray(children) && children.length > 0) {
		            columns = normalize(children)
		        }
		        if (cacheId && typeof cacheId === 'string') {
		            columns = cacheTarget.get(cacheId, columns)
		        }
		        this.showColumnsKeys = [];
		        this.setState({
		            columns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[]),
		            tempColumns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[]),
		            srcColumns: this.setColumOrderByIndex(ObjectAssign(columns) as ColumnType[])
		        });
		    }
		    this.setState({
		        showModal: !!nextProps.columnSetPopover
		    });
		}

		componentWillUnmount() {
		    if (this.scrollTimer) {
		        clearInterval(this.scrollTimer);
		        this.scrollTimer = null;
		    }
		}

		/**
		 * 获取可设置的列
		 *
		 * @param columns 列数组
		 * @returns 返回可设置的列数组
		 */
		// getSetAbleColumn = (columns: ColumnType[]) => {
		//     return columns.filter((col) => {
		//         const { columnSetAble = true } = col;
		//         return columnSetAble;
		//     });
		// }

		checkedColumItemClick = (da: ColumnType) => {
		    let {checkMinSize} = this.props; // 设置最少被选中的
		    let sum = 0,
		        leng = 0;
		    this.state.tempColumns.forEach(da => {
		        da.fixed ? "" : leng++;
		        !da.fixed && da.checked ? sum++ : "";
		    });
		    if (checkMinSize && sum < checkMinSize && da.checked) {
		        return false;
		    } else {
		        if (sum <= 1 && da.checked) return;
		    }
		    da.checked = !da.checked;
		    da.ifshow = !!da.checked;
		    da.isShow = !!da.checked;

		    this.setState({
		        ...this.state
		    });
		    // afterFilter(da, this.state.columns);
		};

		openCloumList = (height?: number) => {
		    // let realHeight = height ? height - 64 - 16 : 0; // 64（QDJCJS-15074），16为最外层内边距
		    // 弹窗最小高度为：200px,
		    if (!height) return;
		    // let outHight = 64 + 16 + 28 + 8 + 26
		    // outHight 142，那么内部列表区域最小高度为200 - 142 = 58
		    // let realHeight = height > 64 ? height - 64 : height > 0 ? height : 0;
		    let boxHeight = height ? height - 64 - 16 - 70 : 0;
		    let realHeight = boxHeight ? boxHeight : 0;
		    if (!this.state.showModal || this.state.adaptiveHeight !== realHeight) {
		        this.setState({
		            showModal: true,
		            adaptiveHeight: realHeight
		        });
		    }
		};

		onHide = () => {
		    if (!('columnSetPopover' in this.props)) {
		        this.setState({
		            showModal: false
		        })
		    }
		}

		onChange = (e: string) => {
		    // console.log(e)
		    this.setState({
		        searchStr: e || ''
		    })
		}

		search = (str: any) => {
		    // return str.title.indexOf(this.state.searchStr) !== -1
		    // return typeof str.title == 'string' ? str.title.indexOf(this.state.searchStr) !== -1 : true; // 兼容处理，不是字符串时的情况
		    const { searchStr } = this.state;
		    if (typeof str.title == 'string') {
		        return str.title.toLocaleLowerCase().indexOf(searchStr.toLocaleLowerCase()) !== -1
		    } else {
		        return this.getChildrenText(str.title).indexOf(searchStr) !== -1
		    }
		}

		/**
		 * 递归获取React元素子集的文本集合
		 * @param elem
		 * @param results
		 * @returns {*}
		 */
		getChildrenText = (elem: HTMLElement | string | undefined, results?: (string | HTMLElement)[]) => {
		    let _results: (string | HTMLElement)[] = results ? results : [];
		    if (!React.isValidElement(elem) && (typeof elem == 'string' || !Object.is(elem, NaN))) {
		        _results.push(elem === undefined ? "" : elem);
		    } else {
		        if (React.isValidElement(elem)) { // react对象则遍历children
		            let self = this;
		            if (Array.isArray((elem.props as HTMLElement).children)) {
		                // @ts-ignore
		                (elem.props as HTMLElement).children.forEach((item: HTMLElement | string) => {
		                    self.getChildrenText(item, _results);
		                })
		            } else {
		                // @ts-ignore
		                self.getChildrenText((elem.props as HTMLElement).children, _results);
		            }
		        }
		    }
		    return _results.join();
		}

		// 递归列锁定和非锁定状态
		setChildColumns = (columns: ColumnType[], fixed: FixedType) => {
		    columns.forEach((da, _i) => {
		        da.fixed = fixed;
		        if (da.children && Array.isArray(da.children) && da.children.length > 0) {
		            this.setChildColumns(da.children as ColumnType[], fixed);
		        }
		    })
		}


		lockClick = (da: ColumnType) => {
		    let {lockIndex, fixed} = da;
		    const {tempColumns} = this.state;
		    tempColumns.forEach((da, i) => {
		        if ((lockIndex || lockIndex === 0) && fixed && i >= lockIndex) {
		            // 如果右固定则保持不动
		            let newFixed = fixed === 'right' ? 'right' : undefined as FixedType;
		            da.fixed = newFixed;
		            if (da.children && Array.isArray(da.children) && da.children.length > 0) {
		                this.setChildColumns(da.children as ColumnType[], fixed);
		            }
		        }

		        if ((lockIndex || lockIndex === 0) && !fixed && i <= lockIndex) {
		            da.fixed = 'left';
		            if (da.children && Array.isArray(da.children) && da.children.length > 0) {
		                this.setChildColumns(da.children as ColumnType[], 'left');
		            }
		        }

		    })

		    this.setState({
		        ...this.state
		    });
		}

		getTargetLockble = (propsLockable: boolean | string): string => {
		    if (typeof propsLockable === 'boolean') {
		        return propsLockable ? 'enable' : 'disable'
		    } else if (typeof propsLockable === 'string') {
		        return propsLockable
		    } else {
		        return 'enable'
		    }
		}

        handleDragStart = (e: React.MouseEvent, index: number, item: ColumnType) => {
            const element = e.currentTarget;

            if (element && this.dragContainerRef.current) {
                const elementRect = element.getBoundingClientRect()
                const mouseY = e.clientY;
                const mouseX = e.clientX;
                const wrap = document.querySelector('.wui-popover.wui-popover-placement-bottomRight')
                const wrapRect = wrap?.getBoundingClientRect()

                // 记录元素的相对于window的位置，用于初始化拖拽定位
                const fixedPosition = {
                    x: elementRect.left,
                    y: elementRect.top
                };

                if (wrapRect) {
                    // 记录元素相对于设有transform的父元素位置，用于计算拖拽位置
                    const offsetPosition = {
                        x: elementRect.left - wrapRect.left,
                        y: elementRect.top - wrapRect.top
                    }

                    this.setState({
                        draggingIndex: index,
                        draggedItem: item,
                        originalPosition: fixedPosition,
                        originalMovePosition: offsetPosition,
                        startClient: { x: mouseX, y: mouseY },
                        diffClient: { x: 0, y: 0 },
                        placeholderIndex: index, // 占位符初始在原位置
                        isDraggingOutside: false,
                        draggedElementRect: elementRect,
                    });
                }
            }
        }

        handleDragMove = (e: React.MouseEvent) => {
            const { draggingIndex, originalPosition } = this.state;
            if (draggingIndex === null) return;

            // 获取鼠标位置
            const mouseY = e.clientY;
            const mouseX = e.clientX;

            if (this.state.startClient && originalPosition) {
                const diffPosition = {
                    x: mouseX - this.state.startClient?.x,
                    y: mouseY - this.state.startClient?.y
                }

                this.setState({
                    diffClient: diffPosition,
                })
            }

            const scrollContainer = this.scrollContainerRef.current

            // 检查是否在容器内
            if (scrollContainer && this.dragContainerRef.current) {
                const containerRect = this.dragContainerRef.current.getBoundingClientRect();
                const scrollContainerRect = scrollContainer.getBoundingClientRect();

                const isInContainer =
                    mouseY >= containerRect.top &&
                    mouseY <= containerRect.bottom &&
                    mouseX >= containerRect.left &&
                    mouseX <= containerRect.right;

                if (isInContainer) {
                    // 自动变换位置
                    this.handleLocationUpdate(mouseY, scrollContainer, scrollContainerRect)
                } else {
                    // 鼠标移出容器，移除占位符
                    this.setState({
                        isDraggingOutside: true,
                        placeholderIndex: null
                    });
                }
            }
        }

        handleDragEnd = (e: React.MouseEvent) => {
            if (this.scrollTimer) {
                clearInterval(this.scrollTimer);
                this.scrollTimer = null;
            }

            const { placeholderIndex, draggingIndex } = this.state;

            // 获取鼠标最终位置
            const mouseY = e.clientY;
            const mouseX = e.clientX;

            let isInContainer = false;
            if (this.dragContainerRef.current && mouseY && mouseX) {
                const containerRect = this.dragContainerRef.current.getBoundingClientRect();
                isInContainer =
                    mouseY >= containerRect.top &&
                    mouseY <= containerRect.bottom &&
                    mouseX >= containerRect.left &&
                    mouseX <= containerRect.right;
            }

            if (isInContainer && placeholderIndex !== null && draggingIndex !== null) {
                // 在容器内且有有效占位符，执行移动
                if (placeholderIndex !== draggingIndex) {
                    const newDragArr = [...this.dragArr];
                    const [draggedItem] = newDragArr.splice(draggingIndex, 1);
                    newDragArr.splice(placeholderIndex, 0, draggedItem);

                    this.dragArr = newDragArr;

                    this.setState({
                        tempColumns: this.unDragArrLeft.concat(newDragArr).concat(this.unDragArrRight),
                        draggingIndex: null,
                        draggedItem: null,
                        originalPosition: null,
                        originalMovePosition: null,
                        startClient: null,
                        diffClient: { x: 0, y: 0 },
                        placeholderIndex: null,
                        isDraggingOutside: false,
                        draggedElementRect: null,
                        // isReturning: false,
                    });
                } else {
                    // 位置未变
                    this.resetDragState();
                }
            } else {
                // 在容器外或无效位置，恢复原位
                this.setState({
                    draggingIndex: null,
                    draggedItem: null,
                    originalPosition: null,
                    originalMovePosition: null,
                    startClient: null,
                    diffClient: { x: 0, y: 0 },
                    placeholderIndex: null,
                    isDraggingOutside: false,
                    draggedElementRect: null,
                    // isReturning: false,
                    // isReturning: true,
                    // diffClient: { x: 0, y: 0 },
                    // placeholderIndex: draggingIndex,
                })
            }
        }

        handleLocationUpdate = (mouseY: number, scrollContainer: HTMLElement, containerRect: DOMRect) => {
            const SCROLL_ZONE = 50 // 滚动触发区域
            const SCROLL_SPEED = 5 // 滚动速度

            if (this.scrollTimer) {
                clearInterval(this.scrollTimer)
                this.scrollTimer = null
            }

            const maxScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight

            if (scrollContainer.scrollTop > 0 && mouseY < containerRect.top + SCROLL_ZONE && mouseY >= containerRect.top) {
                // 向上滚动
                this.setState({isDraggingOutside: false})
                this.scrollTimer = setInterval(() => {
                    scrollContainer.scrollTop -= SCROLL_SPEED
                    // 滚动时重新计算占位符位置
                    this.placeholderUpdate(mouseY)
                }, 11)
            } else if (scrollContainer.scrollTop < maxScroll && mouseY > containerRect.bottom - SCROLL_ZONE && mouseY <= containerRect.bottom) {
                // 向下滚动
                this.setState({isDraggingOutside: false})
                this.scrollTimer = setInterval(() => {
                    scrollContainer.scrollTop += SCROLL_SPEED
                    this.placeholderUpdate(mouseY)
                }, 11)
            } else {
                this.setState({isDraggingOutside: false})
                this.placeholderUpdate(mouseY)
            }
        }

        placeholderUpdate = (mouseY: number) => {
            const { draggingIndex, placeholderIndex } = this.state
            if (draggingIndex === null || !this.dragContainerRef.current) return

            const containerRect = this.dragContainerRef.current.getBoundingClientRect()
            const relativeY = mouseY - containerRect.top
            const itemHeight = 30

            let targetIndex = Math.floor(relativeY / itemHeight)
            targetIndex = Math.max(0, Math.min(targetIndex, this.dragArr.length - 1))

            if (targetIndex !== placeholderIndex) {
                this.setState({
                    placeholderIndex: targetIndex,
                })
            }
        }

        // 重置拖拽状态
        resetDragState = () => {
            this.setState({
                draggingIndex: null,
                draggedItem: null,
                originalPosition: null,
                originalMovePosition: null,
                startClient: null,
                diffClient: { x: 0, y: 0 },
                placeholderIndex: null,
                isDraggingOutside: false,
                draggedElementRect: null,
                // isReturning: false,
            });
        }

		getCloumItem = () => {
		    const {prefixCls, lockable: propsLockable = 'enable', filterCheckboxProps, fieldid, filterColumnRender, dir: direction = 'ltr'} = this.props;
		    let lockable = this.getTargetLockble(propsLockable)
		    const {tempColumns, draggingIndex, isDraggingOutside, placeholderIndex} = this.state;

		    this.dragArr = [];
		    this.unDragArrLeft = [];
		    this.unDragArrRight = [];
		    let fieldidCheckBox = fieldid ? { fieldid: `${fieldid}_check_box` } : {};
		    let fieldidDrag = fieldid ? { fieldid: `${fieldid}_drag` } : {};
		    let fieldidLock = fieldid ? { fieldid: `${fieldid}_lock` } : {};
		    let fieldidUnlock = fieldid ? { fieldid: `${fieldid}_unlock` } : {};
		    let directionAttr = direction === 'rtl' ? { direction } : {};
		    tempColumns.forEach((da, i) => {
		        da.lockIndex = i;
		        const { dataIndex } = da;
		        let isDefaultColumn = dataIndex === 'checkbox' || dataIndex === 'radio' || dataIndex === '_index';
		        if (!isDefaultColumn) {
		            if (da.fixed === true || da.fixed === 'left') {
		                this.unDragArrLeft.push(da);
		            } else if (da.fixed === 'right') {
		                this.unDragArrRight.push(da);
		            } else {
		                this.dragArr.push(da);
		            }
		        }
		    });
		    return (
		        <div>
		            {
		                this.unDragArrLeft.filter(this.search).map((da, i) => {
		                    const { columnSetAble = true, key } = da;
		                    return columnSetAble && !innerColumnKeys.includes(key as string) ? ( // 表现行为和列表展示一致
		                        <div
		                            key={da.key + "_" + i}
		                            data-key={da.key}
		                            className={`${prefixCls}-filter-column-pop-cont-item`}
		                            style={{userSelect: 'none'}}
		                        >
		                            <Icon type="uf-tuodong" { ...fieldidDrag } {...directionAttr}/>
		                            <Checkbox { ...fieldidCheckBox } {...directionAttr} {...((filterCheckboxProps && filterCheckboxProps(da)) || {})} checked={da.checked} disabled>
		                                {(filterColumnRender && typeof filterColumnRender === 'function' ? filterColumnRender(da) : da._originTitle || da.title) as ReactNode}
		                            </Checkbox>
		                            {(lockable === 'enable' || lockable === 'onlyPop') && da.fixed && <Icon type="uf-dongjie" { ...fieldidLock} {...directionAttr} onClick={() => {
		                                this.lockClick(da)
		                            }}/>}
		                            {(lockable === 'enable' || lockable === 'onlyPop') && !da.fixed && <Icon type="uf-weidongjie" { ...fieldidUnlock } {...directionAttr} onClick={() => {
		                                this.lockClick(da)
		                            }}/>}
		                        </div>
		                    ) : null;
		                })
		            }
		            <div
		                ref={this.dragContainerRef}
		            >
		                {
		                    this.dragArr.filter(this.search).map((da, i) => {
		                        const { columnSetAble = true, key } = da;
		                        if (!columnSetAble || innerColumnKeys.includes(key as string)) return null;
		                        const isDragging = draggingIndex === i;
		                        const {originalPosition, draggedElementRect, diffClient, originalMovePosition} = this.state;

		                        // 普通项的样式
		                        let itemStyle: React.CSSProperties = {
		                            zIndex: 1,
		                            // transition: 'transform 1s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
		                            userSelect: 'none',
		                            // position: 'relative',
		                        };

		                        // 拖拽时使用 absolute 定位
		                        if ((isDragging) && originalMovePosition && originalPosition) {
		                            itemStyle = {
		                                zIndex: 5000,
		                                position: 'absolute',
		                                left: originalMovePosition.x,
		                                top: originalMovePosition.y,
		                                margin: 0,
		                                // boxSizing: 'border-box',
		                                width: draggedElementRect?.width || 'auto',
		                                backgroundColor: '#eff1f6',
		                                border: '1px dashed #666',
		                                transition: `
                                            ${/* opacity .2s cubic-bezier(.2, 0, 0, 1), */ ''}
                                            ${/* isReturning ? 'all .3s ease' : 'none' */ ''}
                                        `,
		                                userSelect: 'none',
		                            };
		                        }

		                        return (
		                            <div key={da.key + "_" + i}>
		                                {/* 目标位置指示器 */}
		                                {draggingIndex !== null && !isDraggingOutside && (
		                                    <div
		                                        className={`${prefixCls}-filter-column-placeholder-target`}
		                                        style={{
		                                            height: placeholderIndex === i && placeholderIndex < draggingIndex ? '22px' : 0,
		                                            marginTop: placeholderIndex === i && placeholderIndex < draggingIndex ? '8px' : 0,
		                                            transition: `
                                                        height .1s ease,
                                                        margin-top .1s ease
                                                    `
		                                        }}
		                                    />
		                                )}
		                                <Draggable
		                                    key={da.key + "_drag_" + i}
		                                    handle={`.${prefixCls}-filter-column-drag-handle-${i}`}
		                                    bounds={false}
		                                    enableUserSelectHack={false}
		                                    position={isDragging && diffClient ? diffClient : { x: 0, y: 0 }}
		                                    // disabled={isReturning}
		                                    onStart={(e: any) => this.handleDragStart(e, i, da)}
		                                    onDrag={(e: any) => this.handleDragMove(e)}
		                                    onStop={(e: any) => this.handleDragEnd(e)}
		                                >
		                                    <div
		                                        data-key={da.key}
		                                        className={`${prefixCls}-filter-column-pop-cont-item`}
		                                        style={itemStyle}
		                                    >
		                                        <Icon
		                                            type="uf-tuodong"
		                                            className={`${prefixCls}-filter-column-drag-handle-${i}`}
		                                            style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
		                                            {...fieldidDrag}
		                                            {...directionAttr}
		                                        />
		                                        <Checkbox
		                                            {...fieldidCheckBox}
		                                            {...directionAttr}
		                                            checked={da.checked}
		                                            onClick={isDragging ? undefined : () => this.checkedColumItemClick(da)}
		                                            disabled={isDragging}
		                                            {...((filterCheckboxProps && filterCheckboxProps(da)) || {})}
		                                        >
		                                            {(filterColumnRender && typeof filterColumnRender === 'function' ? filterColumnRender(da) : da._originTitle || da.title) as ReactNode}
		                                        </Checkbox>
		                                        {(lockable === 'enable' || lockable === 'onlyPop') && da.fixed &&
                                                    <Icon type="uf-dongjie" {...fieldidLock} {...directionAttr}
                                                        onClick={isDragging ? undefined : () => this.lockClick(da)} />
		                                        }
		                                        {(lockable === 'enable' || lockable === 'onlyPop') && !da.fixed &&
                                                    <Icon type="uf-weidongjie" {...fieldidUnlock} {...directionAttr}
                                                        onClick={isDragging ? undefined : () => this.lockClick(da)} />
		                                        }
		                                    </div>
		                                </Draggable>

		                                {/* 目标位置指示器 */}
		                                {draggingIndex !== null && !isDraggingOutside && (
		                                    <div
		                                        className={`${prefixCls}-filter-column-placeholder-target`}
		                                        style={{
		                                            height: placeholderIndex === i && placeholderIndex >= draggingIndex ? '22px' : 0,
		                                            marginTop: placeholderIndex === i && placeholderIndex >= draggingIndex ? '8px' : 0,
		                                            transition: `
                                                        height .1s ease,
                                                        margin-top .1s ease
                                                    `
		                                        }}
		                                    />
		                                )}
		                            </div>
		                        );
		                    })
		                }
		            </div>
		            {
		                this.unDragArrRight.filter(this.search).map((da, i) => {
		                    const { columnSetAble = true, key } = da;
		                    return columnSetAble && !innerColumnKeys.includes(key as string) ? ( // 表现行为和列表展示一致
		                        <div
		                            key={da.key + "_" + i}
		                            className={`${prefixCls}-filter-column-pop-cont-item`}
		                            data-key={da.key}
		                            style={{userSelect: 'none'}}
		                        >
		                            <Icon type="uf-tuodong" { ...fieldidDrag } {...directionAttr}/>
		                            <Checkbox { ...fieldidCheckBox } {...directionAttr} {...((filterCheckboxProps && filterCheckboxProps(da)) || {})} checked={da.checked} disabled>
		                                {(filterColumnRender && typeof filterColumnRender === 'function' ? filterColumnRender(da) : da._originTitle || da.title) as ReactNode}
		                            </Checkbox>
		                            {(lockable === 'enable' || lockable === 'onlyPop') && da.fixed && <Icon type="uf-dongjie" { ...fieldidLock} {...directionAttr} onClick={() => {
		                                this.lockClick(da)
		                            }}/>}
		                            {(lockable === 'enable' || lockable === 'onlyPop') && !da.fixed && <Icon type="uf-weidongjie" { ...fieldidUnlock } {...directionAttr} onClick={() => {
		                                this.lockClick(da)
		                            }}/>}
		                        </div>
		                    ) : null;
		                })
		            }
		        </div>
		    );
		};

		clear = (flag: boolean) => { // 全选，重置
		    // srcColumns 原始的数据源
		    // tempColumns 修改，未确定之前，临时的变量,popover展示的数据源\
		    const { onSetColumnReset } = this.props;
		    const {srcColumns, tempColumns} = this.state;
		    let cloneSrcColumns: ColumnType[] = [];
		    if (flag) { // 全选
		        let dataList = tempColumns;
		        let filterListKey = tempColumns.filter(this.search).map(da => da.key || da.dataIndex);
		        cloneSrcColumns = dataList.map((da) => {
		            const columnKey = da.key || da.dataIndex;
		            // 全选时, 列锁定, 要保持原状态
		            if ((flag && da.fixed) || !filterListKey.includes(columnKey)) {
		                return {...da}
		            }
		            return {
		                ...da,
		                checked: flag || this.showColumnsKeys.includes(da.dataIndex),
		                ifshow: flag || this.showColumnsKeys.includes(da.dataIndex),
		                isShow: flag || this.showColumnsKeys.includes(da.dataIndex),
		            }
		        })
		        this.setState({
		            tempColumns: cloneSrcColumns,
		            // searchStr: ''
		        });
		    } else {
		        if (onSetColumnReset && typeof onSetColumnReset === 'function') {
		            cloneSrcColumns = onSetColumnReset(srcColumns);
		            this.setState({
		                tempColumns: cloneSrcColumns,
		                searchStr: ''
		            });
		        } else {
		            let dataList = srcColumns;
		            cloneSrcColumns = dataList.map((da) => {
		                // 全选时, 列锁定, 要保持原状态
		                if (flag && da.fixed) {
		                    return {...da}
		                }
		                return {
		                    ...da,
		                    checked: flag || this.showColumnsKeys.includes(da.dataIndex),
		                    ifshow: flag || this.showColumnsKeys.includes(da.dataIndex),
		                    isShow: flag || this.showColumnsKeys.includes(da.dataIndex),
		                }
		            })
		            this.setState({
		                tempColumns: cloneSrcColumns,
		                searchStr: ''
		            });
		        }
		    }
		};

		// 检测是否显示的列都是固定状态，不允许显示列全部固定
		checkColumn = (tempColumns: any) => {
		    // let isAllFixed = true;
		    let showNum = 0;
		    let fixedNum = 0;
		    for (let i = 0; i < tempColumns.length; i++) {
		        if (tempColumns[i].isShow !== false && tempColumns[i].ifshow !== false) {
		            showNum++
		            if (tempColumns[i].fixed) {
		                fixedNum++
		            }
		        }
		    }
		    return showNum === fixedNum;
		}

		resetFilterColumns = (newColumns: ColumnType[]) => {
		    this.setState({
		        columns: this.setColumOrderByIndex(ObjectAssign(newColumns) as ColumnType[]),
		        tempColumns: this.setColumOrderByIndex(ObjectAssign(newColumns) as ColumnType[]),
		        srcColumns: this.setColumOrderByIndex(ObjectAssign(newColumns) as ColumnType[])
		    });
		}

		setColumns = (newColumns: ColumnType[]) => {
		    return newColumns.map((column: ColumnType, _index: number) => {
		        delete column.innerHeaderIcon;
		        return {
		            ...column,
		            title: column._originTitle || column.title
		        }
		    })
		}

		save = () => {
		    if (this.checkColumn(this.state.tempColumns)) {
		        let propsLocale = this.props.locale || this.context.locale
		    	let locale = getLangInfo(propsLocale, i18n, 'table');
		        Message.destroy();
    			Message.create({ content: `${locale.langMap.cancelLock || '锁定区域超出屏幕范围, 已为您临时取消锁定'}`, color: 'warning' });
		        return;
		    }
		    const { afterFilter, cacheId } = this.props;
		    this.setState({
		        columns: ObjectAssign(this.state.tempColumns) as ColumnType[]
		    })
		    if (cacheId && typeof cacheId === 'string') {
		        cacheTarget.set(cacheId, ObjectAssign(this.state.tempColumns) as ColumnType[]);
		    }
		    afterFilter && afterFilter(this.setColumns(this.state.columns), this.setColumns(this.state.tempColumns));
		    this.onHide()
		};

		// onDragEnd = (result: any) => {
		//     if (!(result.destination) || result.destination?.index === result.source?.index) {
		//         return;
		//     } else {
		//         // const {tempColumns} = this.state
		//         const [removed] = this.dragArr.splice(result.source.index, 1);
		//         this.dragArr.splice(result.destination.index, 0, removed);
		//         this.setState({
		//             tempColumns: this.unDragArrLeft.concat(this.dragArr).concat(this.unDragArrRight)
		//         })
		//     }
		// };

		onVisible = (bool: boolean) => {
		    const { onSetColumnVisibleChange } = this.props;
		    if (bool) { // 弹框显示，同步popover要展示的数据
		        this.setState({
		            tempColumns: ObjectAssign(this.state.columns) as ColumnType[],
		            searchStr: ''
		        });
		    }
		    onSetColumnVisibleChange && onSetColumnVisibleChange(bool);
		}

		lockTableClick = (column: ColumnType, index: number) => {
		    let {lockIndex = index, fixed} = column;
		    const {tempColumns} = this.state;
		    const { afterFilter, cacheId } = this.props;
		    const targetColumns = ObjectAssign([...tempColumns]) as ColumnType[]
		    targetColumns.forEach((da, i) => {
		        if (fixed && i >= lockIndex) {
		            let fixed = da.fixed === 'right' ? 'right' : undefined as FixedType;
		            da.fixed = fixed;
		            if (da.children && Array.isArray(da.children) && da.children.length > 0) {
		                this.setChildColumns(da.children as ColumnType[], fixed);
		            }
		        }

		        if (!fixed && i <= lockIndex) {
		            da.fixed = 'left';
		            if (da.children && Array.isArray(da.children) && da.children.length > 0) {
		                this.setChildColumns(da.children as ColumnType[], 'left');
		            }
		        }

		    })
		    if (this.checkColumn(targetColumns)) {
		        let propsLocale = this.props.locale || this.context.locale
		    	let locale = getLangInfo(propsLocale, i18n, 'table');
		        Message.destroy();
    			Message.create({ content: `${locale.langMap.cancelLock || '锁定区域超出屏幕范围, 已为您临时取消锁定'}`, color: 'warning' });
		        return;
		    }
		    if (cacheId && typeof cacheId === 'string') {
		        cacheTarget.set(cacheId, targetColumns);
		    }
		    this.setState({
		        columns: ObjectAssign(targetColumns) as ColumnType[]
		    })
		    afterFilter && afterFilter(this.setColumns(this.state.columns), this.setColumns(targetColumns));
		}
		lockColumn = (column: ColumnType, index: number) => {
		    // 根据回调重新设置的colunms会带有已经设置的icon功能属性，如拖拽后重新setColumns,所以需要判读是否还需要重新添加
		    const { lockable: propsLockable = 'enable', fieldid, dir: direction = 'ltr' } = this.props;
		    let lockable = this.getTargetLockble(propsLockable)
		    let fieldidLockAttr = fieldid ? { fieldid: `${fieldid}_filter_column_lock_icon` } : {};
		    let fieldidUnlockAttr = fieldid ? { fieldid: `${fieldid}_filter_column_unlock_icon` } : {};
		    let directionAttr = direction === 'rtl' ? { dir: direction } : {};
		    if (column.dataIndex === 'checkbox' || column.dataIndex === 'radio' || column.dataIndex === '_index') {
		        return column;
		    }
		    let wrapClassName = column.fixed ? `${prefix}-table-column-lock ${prefix}-table-column-lock-active` : `${prefix}-table-column-lock`;
		    let lockButton = <div className={`${wrapClassName} ${prefix}-table-title-icon`}>
		        {column.fixed && <Icon type="uf-dongjie" { ...fieldidLockAttr } { ...directionAttr } onClick={() => {
		            this.lockTableClick(column, index)
		        }}/>}
		        {!column.fixed && <Icon type="uf-weidongjie" { ...fieldidUnlockAttr } { ...directionAttr } onClick={() => {
		            this.lockTableClick(column, index)
		        }}/>}
		    </div>;
		    column._originTitle = column._originTitle || column.title;
		    column.title = <>
		        {typeof column.title === 'string' ? <span className={`${prefix}-table-title-text-span`}
														  title={column.title}>{column.title}</span> : column.title}
		        {/* {lockable && !column._hasFilterColumn ? lockButton : null} */}
		    </>;
		    column.innerHeaderIcon = column.innerHeaderIcon || {}
		    if ((lockable === 'enable' || lockable === 'onlyHeader')) {
		        column.innerHeaderIcon.lockButton = lockButton
		    } else {
		        // 消除拖拽等造成的影响
		        column.innerHeaderIcon.lockButton = null
		    }
		    // column._hasFilterColumn = column._hasFilterColumn || true;
		    return column
		}
		renderColums = (columns: ColumnType[]) => {
		    let tempColumns = [];
		    tempColumns = columns.map((originColumn: ColumnType, i: number) => {
		        let column = Object.assign({}, originColumn);
		        return this.lockColumn(column, i);
		    });
		    return tempColumns;
		}

		render() {
		    const {data, prefixCls, fieldid, onFilterColumnRender, filterColumnClassName, dir: direction = 'ltr'} = this.props;
		    const {columns, showModal, adaptiveHeight} = this.state;

		    let propsLocale = this.props.locale || this.context.locale
		    let locale = getLangInfo(propsLocale, i18n, 'table');
		    let fieldidInput = fieldid ? { fieldid } : {};
		    let fieldidReset = fieldid ? { fieldid: `${fieldid}_reset` } : {};
		    let fieldidCancel = fieldid ? { fieldid: `${fieldid}_cancel` } : {};
		    let fieldidOk = fieldid ? { fieldid: `${fieldid}_ok` } : {};
		    let directionAttr = direction === 'rtl' ? { direction } : {};
		    let filterClassName = filterColumnClassName ? `${prefixCls}-filter-column-pop-cont ${filterColumnClassName}` : `${prefixCls}-filter-column-pop-cont`;
		    let middleHeightAttr = adaptiveHeight ? { maxHeight: adaptiveHeight > 105 ? adaptiveHeight : 105, minHeight: '105px' } : {minHeight: '105px'}
		    let content = onFilterColumnRender ? onFilterColumnRender(columns) : (
		        <div className={filterClassName}>
		            <div className={`${prefixCls}-filter-column-pop-header`}>
		                <Input type="search" value={this.state.searchStr} onChange={this.onChange} { ...fieldidInput } { ...directionAttr }
							   onSearch={this.onChange}/>
		            </div>
		            <div className={`${prefixCls}-filter-column-pop-box`}>
		                <div className={`${prefixCls}-filter-column-pop-content`}style={{...middleHeightAttr, overflowY: 'auto'}} ref={this.scrollContainerRef}>
		                    {this.getCloumItem()}
		                </div>
		            </div>
		            <div className={`${prefixCls}-filter-column-pop-footer`}>
		                <span className={`${prefixCls}-filter-column-clear-setting`} onClick={() => this.clear(true)} { ...fieldidReset }>
		                    {locale.langMap.selAll || '全选'}
		                </span>
		                <span className={`${prefixCls}-filter-column-clear-setting`} onClick={() => this.clear(false)} { ...fieldidReset }>
		                    {locale.langMap.resetSettings || '重置'}
		                </span>
		                <Button colors="secondary" size="sm" { ...fieldidCancel } { ...directionAttr } onClick={this.onHide}>{locale.langMap.cancel || '取消'}</Button>
		                <Button colors="primary" size="sm" { ...fieldidOk } { ...directionAttr } onClick={this.save}>{locale.langMap.ok || '确定'}</Button>
		            </div>
		        </div>
		    );

		    return (
		        <Table
		            {...this.props}
		            columns={this.renderColums(columns)}
		            data={data}
		            filterColumnContent={content}
		            filterColumnShowModal={showModal}
		            filterColumnOnHide={this.onHide}
		            filterColumnOnVisibleChange={this.onVisible}
		            filterColumnOpenCloumList={this.openCloumList}
		            resetFilterColumns={this.resetFilterColumns}
		        />
		    );
		}
    }
    return WithConfigConsumer()(FilterColumn) as React.ComponentClass<Partial<TableProps>> | TableInterface;
}
